export default __webpack_public_path__ + "static/media/Available_andriod.84e4f7dd.svg";